<template>
  <div>
    <div class="blog-card">
      <div>
        <slot name="image"></slot>
      </div>
      <div class="blog-card-date">
        <slot name="date"></slot>
      </div>
      <div class="blog-card-title">
        <slot name="title"></slot>
      </div>
      <div class="blog-card-abs">
        <slot name="abstract"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'blog-card'
}
</script>

<style scoped>
  .blog-card{
    display: block;
    width: 420px;
    padding: 15px;
  }
  .blog-card img{
    width: 100%;
    height: 240px;
  }
  .blog-card-title{
   text-align: left;
  }
  .blog-card-date{
    background-color: #9a6e3a;
    width: 30%;
    text-align: left;
    font-size: 18px;
    padding-left: 10px;
    line-height: 25px;
    color: #b3d4fc;
  }
  .blog-card-abs{
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/blog/blog-card.vue